import { Card, Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useForm } from "react-hook-form";
import CrowdCountingEventTiming from "../CrowdCountingEventTiming";
import { useState } from "react";
import CrowdCountingModelSelect from "../CrowdCountingModelSelect";
import CameraLocationsGridView from "../CameraLocationsGridView";

function CrowdCountingEventForm({ event, onSubmit }) {

    const submitHandler = (data, event) => {
        console.log("Form Data:", data);
        console.log("Original Event (optional):", event);
        // Add your custom logic here (e.g., API call, state update)

        var ret = {
            event: {...data, ...timingData},
            locations: locations
        }

        // console.log(ret)
        onSubmit(ret);
    };

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm({ defaultValues: event.event });

    const [timingData, setTimingData] = useState({  is_multi_day: event.event.is_multi_day, start_time: event.event.start_time, end_time: event.event.end_time, display_time: event.event.display_time });
    const [locations, setLocations] = useState(event.locations);
    const [selectedModels, setSelectedModels] = useState([]);


    return (
        <form onSubmit={handleSubmit(submitHandler)}>
            <Grid container spacing={3}>
                <Grid item xs={12} sx={{ transition: 'all 0.7s ease-in-out' }}>

                    <SoftBox >
                        <Grid item xxs={12} md={4} lg={4.5} xxl={5} x4l={7}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography component="label" variant="h5" fontWeight="bold">
                                    Name
                                </SoftTypography>
                                <SoftInput {...register('name')} disabled />
                            </SoftBox>
                        </Grid>

                        <SoftBox mb={4}>
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <SoftTypography component="label" variant="h5" fontWeight="bold">
                                    Timing
                                </SoftTypography>
                            </SoftBox>
                            <SoftBox mb={1}>
                                <Card sx={{ border: "rgb(210, 214, 218) 1px solid", boxShadow: 0 }}>
                                    <SoftBox mx={2} >
                                        <Grid container spacing={3} direction="row" justifyContent="flex-start">
                                            <Grid item xxs={12} lg={3}>
                                                <CrowdCountingEventTiming {...{ timingData, setTimingData, isView: false }}></CrowdCountingEventTiming>
                                            </Grid>
                                        </Grid>
                                    </SoftBox>
                                </Card>
                            </SoftBox>
                        </SoftBox>

                        {/* <SoftBox mb={4}>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                    <SoftTypography component="label" variant="h5" fontWeight="bold">
                        Model
                    </SoftTypography>

                </SoftBox>
                <SoftBox mb={1}>
                    <Card sx={{ border: "rgb(210, 214, 218) 1px solid", boxShadow: 0 }}>
                        <SoftBox mx={2} >
                            <Grid container spacing={3} direction="row" justifyContent="flex-start">
                                <Grid item xxs={12} lg={12}>
                                    <CrowdCountingModelSelect {...{ selectedModels, setSelectedModels }} />
                                </Grid>
                            </Grid>
                        </SoftBox>
                    </Card>
                </SoftBox>
            </SoftBox> */}

                    </SoftBox>
                </Grid >
                <Grid item xs={12} sx={{ transition: 'all 0.7s ease-in-out' }}>
                    <SoftBox >
                        <SoftTypography variant="h5">Sites</SoftTypography>
                    </SoftBox>
                    <CameraLocationsGridView {...{ locations, setLocations }}></CameraLocationsGridView>
                </Grid >
            </Grid >
            <input type="submit" />
        </form>
    )
}

export default CrowdCountingEventForm;